import { Skeleton } from '@/shared/components';
import { useMediaQuery } from '@/shared/lib';

const SkeletonItem = () => (
  <Skeleton variant="medium" className="h-[4.2rem] w-[10rem] bg-white" />
);

const HistoryFilterSkeleton = () => {
  const isMobile = useMediaQuery('(max-width: 400px)');

  return (
    <div className="flex justify-between gap-[1.6rem]">
      <div className="flex gap-[1.6rem]">
        <SkeletonItem />

        {!isMobile && (
          <>
            <SkeletonItem />
            <SkeletonItem />
          </>
        )}
      </div>

      <SkeletonItem />
    </div>
  );
};

export { HistoryFilterSkeleton };
